module.exports = __webpack_public_path__ + "static/media/survey.a6998b1c.svg";